import { SET_TOGGLE } from './types';

export const setSideBarToggle = (value) => {
	return {
		type: SET_TOGGLE,
		payload: value
	};
};